import React, { Fragment, useRef, useState } from 'react';
import { ContactButton, MainNavigation, MarketButton, SearchButton, SignInButton } from './components';
import { MegaMenuNavigationItem } from '@layouts/MegaMenu/MegaMenu.types';
import './MenuSection.scss';
import { useWinSize } from '@contexts/WinSizeContext';
import { activeClass } from '@layouts/Header/Header.utils';
import { IconContainer, Profile } from '@icons/common';
import { SignInLinkInformation } from '@layouts/Header/Header.types';
import classNames from 'classnames';

interface MenuSectionProps {
  toggleMegaMenu: (index: string) => void;
  toggleSearchArea: () => void;
  toggleSignInArea: () => void;
  toggleMarketArea: () => void;
  showHideSignIn: boolean;
  megaMenuNavigation: MegaMenuNavigationItem[];
  contactLink: string;
  contactBtnText: string;
  searchBtnText: string;
  signInBtnText: string;
  selected: string;
  signInDescription: string;
  signInBtnLinks: SignInLinkInformation[];
  showSearchArea: boolean;
  showSignInArea: boolean;
  showMarketArea: boolean;
  cls: string;
}

export const MenuSection = ({
  toggleMegaMenu,
  toggleSearchArea,
  toggleSignInArea,
  toggleMarketArea,
  showHideSignIn,
  megaMenuNavigation,
  contactLink,
  contactBtnText,
  searchBtnText,
  signInBtnText,
  selected,
  signInDescription,
  showSearchArea,
  showSignInArea,
  showMarketArea,
  signInBtnLinks,
  cls,
}: MenuSectionProps) => {
  const [contactClick, setContactClick] = useState(false);
  const contactBtnRef = useRef<HTMLAnchorElement>();
  const { isDesktopForHeader } = useWinSize();
  const handlehighlight = (index: string) => {
    setContactClick(true);
    toggleMegaMenu(index);
    if (window.pageType === 'ContactUsPage' && contactBtnRef.current) {
      contactBtnRef.current.classList.remove('active');
    }
  };
  let pathLink = '';

  if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'nl') {
    pathLink = '/nl/';
  } else if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'fr-BE') {
    pathLink = '/fr-be/';
  } else if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'fr-CA') {
    pathLink = '/fr-ca/';
  } else {
    pathLink = '/';
  }
  return (
    <Fragment>
      <div className='l-header-main-menu'>
        <div className='l-header-main-menu-left'>
          <MainNavigation
            model={megaMenuNavigation}
            onClick={(index: string) => handlehighlight(index)}
            selected={selected}
          />
          <ContactButton
            ref={contactBtnRef}
            selected={selected}
            title={contactBtnText}
            highlight={contactClick}
            contactlink={window.location.origin + pathLink + contactLink}
          />
        </div>
        <div
          className={classNames(
            `l-header-main-menu-right`,
            isDesktopForHeader && !showHideSignIn ? 'search-sign-in-right' : ''
          )}
        >
          <SearchButton
            onClick={toggleSearchArea}
            selected={showSearchArea}
            title={searchBtnText}
          />
          {(signInBtnLinks.length > 0 || signInDescription) && !showHideSignIn && (
            <SignInButton
              onClick={toggleSignInArea}
              selected={showSignInArea}
              title={signInBtnText}
            />
          )}
          <MarketButton
            onClick={toggleMarketArea}
            selected={showMarketArea}
            title={window.lang.toUpperCase()}
          />
        </div>
      </div>
      <div className={`${cls}-main-mobile-item`}>
        {(!showHideSignIn ||
          (showHideSignIn && !isDesktopForHeader) ||
          window.innerWidth == 900) && (
          <div
            className={activeClass('c-animation-box mobile-right-icon', showSearchArea, false)}
            onClick={toggleSearchArea}
          >
            <ul>
              <li>
                <i className='svg-icon icon-symbol-close'></i>
              </li>
              <li>
                <i className='svg-icon icon-symbol-search'></i>
              </li>
            </ul>
          </div>
        )}
        {(signInBtnLinks.length > 0 || signInDescription) && !showHideSignIn && (
          <div
            className={activeClass(
              'c-animation-box mobile-right-icon sign-in-area',
              !showHideSignIn,
              false
            )}
            onClick={toggleSignInArea}
          >
            <ul>
              <li>
                <i className='svg-icon icon-symbol-close'></i>
              </li>
              <li>
                <IconContainer icon={<Profile />} className='svg-icon icon-sign-in' />
              </li>
            </ul>
          </div>
        )}
        <div
            className={activeClass(
              'c-animation-box mobile-right-icon market-area',
              !showHideSignIn,
              false
            )}
            onClick={toggleMarketArea}
          >
            <ul>
              <li>
                <i className='svg-icon icon-symbol-close'></i>
              </li>
              <li>
                <i className='svg-icon icon-sphere' />
              </li>
            </ul>
          </div>
      </div>
    </Fragment>
  );
};
